import { render, staticRenderFns } from "./LoanderUltimosDiarios.vue?vue&type=template&id=2b59d17a&"
import script from "./LoanderUltimosDiarios.vue?vue&type=script&lang=js&"
export * from "./LoanderUltimosDiarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports